<template>
  <ul class="product-inline-buttons">
    <li
      v-if="displaySizeGuide && inlineSizeGuideButton"
      class="product-inline-buttons__item"
    >
      <button
        class="button button--with-icon product-inline-buttons__size-guide product-inline-buttons__button"
        type="button"
        aria-haspopup="dialog"
        @click.prevent="toggleSizeGuidePopup"
      >
        <span
          v-if="inlineSizeGuideButton.title"
          class="button__label"
          v-text="inlineSizeGuideButton.title"
        />
        <span
          v-if="inlineSizeGuideButton.icon?.svg"
          class="button__icon"
          role="img"
          :aria-label="inlineSizeGuideButton.icon?.title"
          v-html="inlineSizeGuideButton.icon.svg"
        />
      </button>
    </li>

    <li
      v-for="(button, index) in inlineButtons"
      :key="index"
      class="product-inline-buttons__item"
    >
      <a
        :href="formatURL(button.url)"
        class="product-inline-buttons__button button button--with-icon"
      >
        <span
          v-if="button.title"
          class="button__label"
          v-text="button.title"
        />
        <span
          v-if="button.icon?.svg"
          class="button__icon"
          role="img"
          :aria-label="button.icon?.title"
          v-html="button.icon.svg"
        />
      </a>
    </li>
  </ul>
</template>

<script>

/**
 * Component: Product Inline Buttons
 * -----------------------------------------------------------------------------
 * - Reusable component for product inline buttons (inluding Size Guide).
 * @param {Boolean} displaySizeGuide - Whether the Size Guide is enabled and should be displayed.
 * @param {Boolean|Object} inlineSizeGuideButton - Configured metaobject for the Inline Size Guide button.
 * @param {Array} inlineButtons - Formatted PDP Inline Buttons array.
 */

import { getLocalUrl } from '~/helpers/format'

export default {
  name: 'ProductInlineButtons',

  props: {
    displaySizeGuide: {
      type: Boolean,
      default: false,
    },
    inlineSizeGuideButton: {
      type: [ Boolean, Object ],
      default: false,
    },
    inlineButtons: {
      type: Array,
      default: () => [],
    },
  },

  emits: [ 'on-size-guide-popup-toggle' ],

  methods: {

    /**
     * Convert a relative or full store URL to a localised version
     * @param url - URL to format.
     * @returns {String}
     */
    formatURL(url) {
      return getLocalUrl(url)
    },

    /**
     * Toggle the state of the 'Size Guide' popup.
     * @emits `on-size-guide-popup-toggle`
     */
    toggleSizeGuidePopup() {
      this.$emit('on-size-guide-popup-toggle')
    },
  },
}
</script>
